import {AppProvider} from '@shopify/polaris';

export default AppProvider;